export const WHITELIST_INTERCEPTOR_ERRORS: string[] = [
  'api/ping',
  'build.txt'
];
